module.exports = __webpack_public_path__ + "static/img/product_3.25eb769.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mobile/english/product_3.png
// module id = PyX6
// module chunks = 15